import { createAsyncActions } from '@/store/async/async.actions';

export const setSubscriptionInfo = createAsyncActions('SET_SUBSCRIPTION_INFO');
